import request from "@/utils/http"

export function uploadAttachment(file) {
  return request.post("/sheet/attachment", file)
}

export function checkAttachment(hashCode) {
  return request({
    url: "/sheet/attachment/check/" + hashCode,
    method: "get"
  })
}

export function getAttachmentList({ marked = false, search = "", page = 1, size = 20 } = {}) {
  return request({
    url: "/sheet/attachment/list",
    method: "get",
    params: {
      marked,
      search,
      page,
      size
    }
  })
}

export function updateAttachment(attachment) {
  return request({
    url: "/sheet/attachment/update",
    method: "post",
    data: attachment
  })
}

export function getAttachmentHistory(fileId) {
  return request.get("/sheet/getAttachmentHistory", { params: { fileId } }).commonDeal()
}

export function getDownloadRecord(fileId) {
  return request.get("/sheet/getDownloadRecord", { params: { fileId } }).commonDeal()
}

export function downloadAttachment(attachmentId) {
  return request.post("/sheet/downloadAttachment", null,{ params: { attachmentId } }).commonDeal()
}

export function getAttachmentListById(fileIds) {
  return request.post("/sheet/getAttachmentListById", fileIds).commonDeal()
}

export function deleteAttachment(attachments) {
  return request({
    url: "/sheet/attachment/delete",
    method: "post",
    data: attachments
  })
}
